import gsap, { Expo } from 'gsap';

class Preloader {
    constructor() {
        this.html = document.querySelector('html');
        this.el = document.querySelector('.embrace-preloader');
        this.blue = this.el.querySelector('.embrace-preloader__container');
        this.brandOverlay = this.el.querySelector('.embrace-preloader__brand-overlay');
    }

    progress(progress) {
        gsap.to(this.brandOverlay, {
            duration: 1,
            ease: Expo.easeOut,
            left: progress + '%',
        });
    }

    animate() {
        const tl = gsap.timeline({ delay: 1.5 });

        tl.to(this.blue, {
            duration: 1,
            ease: Expo.easeInOut,
            clipPath: 'inset(0 0 100% 0)',
            webkitClipPath: 'inset(0 0 100% 0)',
            onComplete: () => {
                this.dispose();
            }
        }, '-=1')
    }

    dispose() {
        this.el.remove();
        this.html.removeAttribute('data-loading');
    }
}

export default Preloader;
